var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cloneElement, isValidElement } from 'react';
import { useTranslate } from 'react-admin';
import { ListSubheader, styled, alpha, getOverlayAlpha } from '@mui/material';
import { SearchResultItem } from './SearchResultItem';
/**
 * A component which displays search results for a specific target.
 *
 * @param props {SearchResultsGroupProps}
 * @param props.data {SearchResultDataItem[]} The search results
 * @param props.label {ReactElement|string} The target label
 * @param props.onClose {Function} The function to call when the Search PopOver should be closed.
 */
export var SearchResultsGroup = function (props) {
    var _a = props.children, children = _a === void 0 ? defaultChildren : _a, data = props.data, label = props.label, onClose = props.onClose;
    var translate = useTranslate();
    return (_jsxs(_Fragment, { children: [_jsxs(Root, { component: "h5", role: "presentation", children: [label != null
                        ? isValidElement(label)
                            ? label
                            : translate(label.toString(), { _: label })
                        : null, _jsx("span", { children: translate('ra-search.result', {
                            smart_count: data === null || data === void 0 ? void 0 : data.length,
                            _: '1 result |||| %{smart_count} results',
                        }) })] }), data === null || data === void 0 ? void 0 : data.map(function (searchResultItem) {
                return cloneElement(children, {
                    key: searchResultItem.id,
                    data: searchResultItem,
                    onClose: onClose,
                });
            })] }));
};
var Root = styled(ListSubheader)(function (_a) {
    var theme = _a.theme;
    return (__assign({ lineHeight: theme.spacing(4), marginBottom: 1, marginTop: 1, backgroundColor: theme.palette.background.paper, display: 'flex', justifyContent: 'space-between' }, (theme.palette.mode === 'dark' && {
        backgroundImage: "linear-gradient(".concat(alpha('#fff', 
        //@ts-ignore
        getOverlayAlpha(4)), ", ").concat(alpha('#fff', 
        //@ts-ignore
        getOverlayAlpha(4)), ")"),
    })));
});
var defaultChildren = _jsx(SearchResultItem, {});
